<template>
  <div class="saveSelfPoster">
    <div class="saveSelfPoster-text">
      <p @click="copyInviteMsg()">一键复制邀请语</p>
    </div>
    <div class="saveSelfPoster-main">
      <div class="saveSelfPoster-content">
        <img :src="posterUrl" alt="海报图片"
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
        >
      </div>
    </div>
    <imgShare
      :imgUrl="posterUrl"
      @shareClick="handleShareClick"
      @appShareBack="handleAppShareBack"
    />
  </div>
</template>

<script>
import Clipboard from '../utils/clipBoard'
import imgShare from '@/inviteNew/components/ImgShare'

export default {
  name: 'saveSelfPoster',
  components: { imgShare },
  data () {
    return {
      posterUrl: '', // 合成的海报图片地址
      inviteMsg: '最近孩子一直在学而思网校上课，课上有名师教分析思维，课前课后有辅导老师贴心指导，孩子喜欢我也就放心了。强力安利给大家！扫码立减100。'
    }
  },
  created () {
    this.posterUrl = sessionStorage.getItem('posterImgUrl') || ''
  },
  methods: {
    /**
     * 右上角 一键复制邀请语
     */
    copyInviteMsg () {
      this.$xesLogger.clickMsg({ params: { action: 'copyInviteMsg', clickid: '5.3.12' } })
      const copyResult = Clipboard.copy(this.inviteMsg)
      const messageTips = copyResult ? '复制成功，快去邀请好友吧！' : '当前环境不支持，请通过海报分享'
      return this.$toast(messageTips)
    },
    /**
     * 海报长按判断
     */
    touchStart () {
      this.isLongPress = false
      this.timer = setTimeout(() => {
        this.isLongPress = true
        this.$xesLogger.clickMsg({ params: { action: 'longPress', clickid: '5.3.18', posterId: this.$route.query.posterId } })
      }, 600)
    },
    touchMove () {
      // 清除定时器
      clearTimeout(this.timer)
      this.timer = null
    },
    touchEnd () {
      clearTimeout(this.timer)
      this.timer = null
    },
    /**
     * 分享按钮点击（shareFixed 回传）。
     */
    handleShareClick (scence) {
      // app分享图标被点击事件，记录点击触发日志
      this.$xesLogger.clickMsg({
        params: { action: 'handleShareClick', clickid: '10.3', posterId: this.$route.query.posterId, scence }
      })
    },
    /**
     * 分享结果回调
     */
    handleAppShareBack (data) {
      // 分享的结果回调方法， 1 成功，2 失败，3 取消
      this.$xesLogger.clickMsg({
        params: { action: 'handleAppShareBack', clickid: '10.4', posterId: this.$route.query.posterId, scence: data.scence, sharestatus: `${data.status}` }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.saveSelfPoster {
  background-image: url('../assets/images/bg-posterList.png');
  background-size: cover;

  &-text {
    position: fixed;
    top: 40px;
    right: -9px;

    p {
      height: 23px;
      padding-left: 9px;
      padding-right: 18px; // 9+9(left)
      font-size: 11px;
      font-weight: 400;
      line-height: 23px;
      color: #fff;
      background: #f2364a;
      border-radius: 12px;
    }
  }

  &-main {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding-top: 80px;
  }

  .saveSelfPoster-content {
    padding: 0 40px 0;
  }
}
</style>
